import { Pipe, PipeTransform } from "@angular/core";
import { capitalize } from "lodash";

@Pipe({ name: "capitalizeCase" })
export class CapitalizeCasePipe implements PipeTransform {
  transform(value: string, apply = true): unknown {
    if (typeof value !== "string" || !apply) {
      return value;
    }

    return capitalize(value);
  }
}
